<template>
  <div>
    <b-navbar
      toggleable="lg"
      type="dark"
      class="p-0 text-lg-right flex-lg-row-reverse"
      :class="!userIsAParent ? 'flex-row-reverse bg-main2' : 'bg-main'"
      sticky
    >
      <!-- parent menu button -->
      <b-button class="bg-main button--menu" v-b-toggle.sidebar-menu>
        <span class="material-icons">menu</span>
      </b-button>
      <!-- /parent menu button -->

      <!-- parent button section -->
      <b-navbar-brand v-if="!userIsAParent" @click="goParent()" class="pl-3" style="cursor:pointer">
        <span class="material-icons align-middle text-white">
          person
        </span>
      </b-navbar-brand>
      <!-- /parent button section -->

      <div class="d-flex justify-content-center pt-md-3 pt-2 pr-2 pr-sm-none flex-gap">
        <router-link to="/" class="d-flex flex-column align-items-center darker-hover">
          <div class="home-button-image-container">
            <img :src="require(`@/assets/icons/navbar/Home.svg`)" alt="" />
          </div>
          <span class="text-light">Home</span>
        </router-link>
        <child-users v-if="userIsAParent" />
        <notifications class="pr-2 pr-md-5 pr-sm-2" />
      </div>
      <!-- parent menu -->
      <b-sidebar id="sidebar-menu" backdrop-variant="dark" backdrop shadow>
        <b-navbar-nav class="d-lg-none">
          <b-nav-item
            v-for="(item, idx) in items.oneItems"
            v-bind:key="'one' + idx"
            @click="$router.push(`${item.router}`)"
            class="nav-item-style"
            :title="item.title"
          >
            <div class="nav-bar-item-image-container ml-4">
              <img :src="item.img" :alt="item.title" />
            </div>
            <span class="text-light">
              {{ item.title }}
            </span>
          </b-nav-item>

          <hr class="mx-4 my-3" />
          <b-nav-item
            v-for="(item, idx) in items.twoItems"
            v-bind:key="'two' + idx"
            @click="$router.push(`${item.router}`)"
            class="nav-item-style"
            :title="item.title"
          >
            <div class="nav-bar-item-image-container ml-4">
              <img :src="item.img" :alt="item.img" />
            </div>
            <span class="text-light">
              {{ item.title }}
            </span>
          </b-nav-item>
        </b-navbar-nav>
      </b-sidebar>
      <!-- /parent menu -->

      <!-- child home button -->
      <b-navbar-nav
        v-if="!userIsAParent"
        class="mx-3 my-1 text-light mr-auto"
        @click="$router.push('/')"
      >
        <b-link class="material-icons align-middle text-white">
          home
        </b-link>
      </b-navbar-nav>
      <!-- /child home button -->
    </b-navbar>
  </div>
</template>
<script>
import notifications from '@/components/general/notificationsDropdown.vue';
import childUsers from '@/components/general/childUsersDropdown.vue';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { getIcon } from '@/utils/getIcon.js';

export default {
  components: {
    notifications,
    childUsers,
  },
  methods: {
    ...mapMutations('user', ['setUserType', 'setUserData']),
    ...mapActions('user', ['getUserData']),
    goParent() {
      if (this.$route.name == 'Home') {
        this.setUserType('parent');
        this.setUserData(this.getParentData);
      } else {
        this.$router
          .push({ name: 'Home' })
          .then(() => {
            this.setUserType('parent');
            this.setUserData(this.getParentData);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  },
  computed: {
    ...mapGetters('user', ['userIsAParent', 'getParentData', 'getUserId']),
    items() {
      return {
        oneItems: [
          {
            title: 'Home',
            img: getIcon('Home'),
            router: '/',
          },
          {
            title: 'Child Challenge',
            img: getIcon('ChildChallenge'),
            router: '/challenge-select-child?next=challenge-parent-approve',
          },
          {
            title: 'Rewards',
            img: getIcon('Rewards'),
            router: '/rewards',
          },
          {
            title: 'Parent Goals',
            img: getIcon('GoalsParents'),
            router: '/parent-goals',
          },
          {
            title: 'Skill Visuals and Videos',
            img: getIcon('SkillVisual'),
            router: '/plan-select-skill?type=learn',
          },
          {
            title: 'Surveys',
            img: getIcon('Surveys'),
            router: '/surveys',
          },
          {
            title: 'Progress',
            img: getIcon('Progress'),
            router: '/progress',
          },
          {
            title: 'Badges',
            img: getIcon('Badges'),
            router: '/badges',
          },
          {
            title: 'Parenting Solutions',
            img: getIcon('ProblemSolving'),
            router: '/help-main',
          },
        ],
        twoItems: [
          {
            title: 'FAQ',
            img: getIcon('FAQ'),
            router: '/faq',
          },
          {
            title: 'Settings',
            img: getIcon('Settings'),
            router: '/settings',
          },
          {
            title: 'Log out',
            img: getIcon('LogOut'),
            router: '/logout',
          },
        ],
      };
    },
  },
};
</script>

<style lang="scss">
.nav-item {
  a:hover {
    background: linear-gradient(rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25));
  }
}
.button--menu {
  line-height: 0;
}

#sidebar-menu {
  background-color: var(--color-main) !important;
  @media screen and (max-width: 480px) {
    width: 100%;
  }
}
</style>

<style lang="scss">
.nav-item {
  a:hover {
    background: linear-gradient(rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25));
  }
}
</style>

<style lang="scss">
.navbar-nav {
  @media (max-width: 992px) {
    position: fixed !important;
    background: var(--color-main) !important;
    padding-bottom: 5rem;

    li {
      &:last-of-type {
        padding-bottom: 3rem;
      }
    }
  }

  @media (max-width: 430px) {
    width: 100%;
    li {
      &:last-of-type {
        padding-bottom: 9rem;
      }
    }
  }

  height: 100vh !important;
  overflow-y: auto;
  overflow-x: hidden;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  // width: 25vw
  .mobile-nav-bar-item {
    width: 100vw !important;
    & > a {
      display: flex;
      gap: 1rem;
    }
  }
}

.home-button-image-container {
  width: 40px;
  & > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.navbar-nav::-webkit-scrollbar {
  display: none;
}
</style>
